import React, { useContext } from "react";
import AppLayout from "../Layout/AppLayout";
import { makeStyles } from "@material-ui/styles";
import { Grid, Typography } from "@material-ui/core";
import { LangContext } from "../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    height: "100vh",
  },
  headtext: {
    fontWeight: 700,
    fontSize: "1.2rem",
    color: "#595A5A",
  },
  cardapi: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    minHeight: "-webkit-fill-available",
    maxHeight: "100%",
  },
  page: {
    height: "calc(100vh - 8.1rem)",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
    overflowY: "auto",
  },
  paragraph: {
    fontWeight: 200,
    fontSize: "1rem",
    color: "#595A5A",
  },
  text404: {
    background:
      " -webkit-linear-gradient(180deg, rgba(255,229,189,1) 0%, rgba(254,211,140,1) 25%, rgba(246,169,150,1) 70%, rgba(239,135,159,1) 91%)",
    fontWeight: 700,
    fontSize: "10rem",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  textNotfount: {
    background:
      " -webkit-linear-gradient(180deg, rgba(255,229,189,1) 0%, rgba(254,211,140,1) 25%, rgba(246,169,150,1) 70%, rgba(239,135,159,1) 91%)",
    fontWeight: 700,
    fontSize: "5rem",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
}));

const Error = () => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  React.useEffect(() => {
    document.title = `404 Not Found | ${lang.MEAtitle}`;
    return () => {};
  }, [lang]);

  return (
    <AppLayout>
      <div className={classes.root}>
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <div className={classes.page}>
              <Typography className={classes.text404}>404</Typography>
              <Typography className={classes.textNotfount}>
                Not found
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </AppLayout>
  );
};
export default Error;
